"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentCollectionAction = exports.SubscriptionAction = exports.UserStatus = void 0;
exports.UserStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
};
exports.SubscriptionAction = {
    None: 'None',
    Checkout: 'Checkout',
    Downgraded: 'Downgraded',
    UpgradeViaSales: 'UpgradeViaSales',
    DowngradeViaSales: 'DowngradeViaSales',
};
exports.PaymentCollectionAction = {
    Pause: 'Pause',
    Unpause: 'Unpause',
};
